import styled from 'styled-components'
import { generateMedia } from 'styled-media-query'

const media = generateMedia({
  xs: '250px',
  sm: '668px',
  md: '768px',
  lg: '1200px',
})
export const Background = styled.div`
background: rgba(0, 0, 0, 0.4);
top: 0;
right: 0;
left: 0;
bottom: 0;
position: fixed;
z-index: 99;
`
export const Header = styled.div`
h1{
font-family: 'Comfortaa';
font-style: normal;
font-weight: 400;
font-size: 25px;
line-height: 33px;
color: #000000;
margin-left: 30%;
}
display: flex;
flex-direction: row-reverse;
height: 5%;
width: 100%;
justify-content: space-between;
${media.between('sm', 'md')`
 font-size: 12px;
`}
${media.between('xs', 'sm')`
font-size: 10px;
`}
${media.lessThan('xs')`
font-size: 7px;
`}
button{
  border-radius: 2rem;
  min-width: 0.5%;
  min-height: 0,5%;
  margin: 0;
  width:0.5%;
  height: 0.5%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  color: black;
  background-color: white;
}
`
export const BodyContainer = styled.div`
display: flex;
${media.lessThan('sm')`
 flex-direction:column;
 overflow:auto;
`}
`
export const Wrapper = styled.div`
display: flex;
flex-direction: column;
margin-left: 12.5%;
margin-right: 12.5%;
margin-bottom: 1%;
margin-top: 1%;
padding: 1%;
width: 75%;
height: 95%;
background: #FFFFFF;;
box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
border-radius: 10px;
${media.between('sm', 'md')`
 height: 80%;
`}
${media.lessThan('sm')`
height: 100%;
`}

z-index: 100;
`
